import React from 'react'
import PropTypes from 'prop-types'

import { TextField, CircularProgress, InputAdornment } from '@material-ui/core'

import helpers from 'helpers'
import * as service from 'service'

const removeCepMask = (cep = '') => {
  return cep.replace(/-/g, '')
}

export default function InputCep({ onChange, onBlur, onRequest, ...rest }) {
  const [value, setValue] = React.useState(rest.value)
  const [loading, setLoading] = React.useState(false)

  React.useEffect(() => {
    setValue(helpers.people.formatCep(rest.value))
  }, [rest.value])

  const requestCep = () => {
    if (!onRequest || value.length !== 9) {
      return
    }

    setLoading(true)
    service.recurrence.cep
      .get({ postalCode: value })
      .then(({ data }) => {
        setLoading(true)
        onRequest(data)
      })
      .catch(() => {
        onRequest(null)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const handleChange = event => {
    const formattedValue = helpers.people.formatCep(event.target.value)
    const valueWithoutMask = removeCepMask(event.target.value)

    onChange({ target: { name: rest.name, value: valueWithoutMask } })
    setValue(formattedValue)
  }

  const handleBlur = event => {
    if (onBlur) {
      onBlur(event)
    }

    requestCep()
  }

  return (
    <TextField
      {...rest}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      disabled={loading}
      InputProps={{
        endAdornment: loading && (
          <InputAdornment position="end">
            <CircularProgress size={20} />
          </InputAdornment>
        ),
      }}
    />
  )
}

InputCep.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onRequest: PropTypes.func,
}
